import { usePreQuestions } from "@/components/features/items/edit/_shared/ui/components/main/questions/pre-question/hooks";

import { useProductDayTripPlanI18nFormModelContext } from "../../../../../_context";

export const useDayTripPlanI18nPreQuestions = () => {
	const { viewModel, onSetViewModel } = useProductDayTripPlanI18nFormModelContext();
	const { questions } = viewModel;

	return {
		...usePreQuestions({ questions, onSetViewModel }),
	};
};
